import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ActivityTypeService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { ActivityType } from '../../models'

const log = new Logger('ActivityTypeResolver')
@Injectable({ providedIn: 'root' })
export class ActivityTypeResolver implements Resolve<Observable<ActivityType>> {
  constructor(
    private resService: ActivityTypeService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['aid']
    
    return this.resService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/activity-type']))
    )
  }
}
